var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import CloseOutlined from '@shopee/solar-icons/CloseOutlined';
import LeftOutlined from '@shopee/solar-icons/LeftOutlined';
import RightOutlined from '@shopee/solar-icons/RightOutlined';
import RotateLeftOutlined from '@shopee/solar-icons/RotateLeftOutlined';
import RotateRightOutlined from '@shopee/solar-icons/RotateRightOutlined';
import ZoomInOutlined from '@shopee/solar-icons/ZoomInOutlined';
import ZoomOutOutlined from '@shopee/solar-icons/ZoomOutOutlined';
import RcImage from 'rc-image';
import * as React from 'react';
import { ConfigContext } from '../config-provider';
import { getTransitionName } from '../_util/motion';
export const icons = {
    rotateLeft: React.createElement(RotateLeftOutlined, null),
    rotateRight: React.createElement(RotateRightOutlined, null),
    zoomIn: React.createElement(ZoomInOutlined, null),
    zoomOut: React.createElement(ZoomOutOutlined, null),
    close: React.createElement(CloseOutlined, null),
    left: React.createElement(LeftOutlined, null),
    right: React.createElement(RightOutlined, null),
};
const InternalPreviewGroup = (_a) => {
    var { previewPrefixCls: customizePrefixCls, preview } = _a, props = __rest(_a, ["previewPrefixCls", "preview"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('image-preview', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const mergedPreview = React.useMemo(() => {
        if (preview === false) {
            return preview;
        }
        const _preview = typeof preview === 'object' ? preview : {};
        return Object.assign(Object.assign({}, _preview), { transitionName: getTransitionName(rootPrefixCls, 'zoom', _preview.transitionName), maskTransitionName: getTransitionName(rootPrefixCls, 'fade', _preview.maskTransitionName) });
    }, [preview]);
    return (React.createElement(RcImage.PreviewGroup, Object.assign({ preview: mergedPreview, previewPrefixCls: prefixCls, icons: icons }, props)));
};
export default InternalPreviewGroup;
